import { makeStyles } from 'lib/components';

export default makeStyles(() => ({
  serviceAgreementPaper: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '0px',
    padding: '24px',
    width: '100%',
    borderRadius: '0px',
    '@media (min-width: 640px)': {
      borderRadius: '4px',
      margin: '16px 24px 16px 24px',
      width: 'auto',
    },
  },
  deatilsContainer: {
    display: 'flex',
    gap: '24px',
  },
  deatilsSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
}));
